import React from "react";

import "./coming.styles.scss";

const ComingSoon = () => {
  return <div className="coming container"> Coming soon!!! </div>;
};

export default ComingSoon;
